export const HandleEloquaError = (error) => {
	if (process.env.GATSBY_CONTENTSTACK_ENVIRONMENT !== 'production') {
		// eslint-disable-next-line no-console -- development only
		console.error('Error while sending data to Eloqua:', error);
	}
	// add Sentry here?
};
